
import { AdvancedFind } from './AdvancedFind';
export class ColumnBinarySearch extends AdvancedFind {
    constructor(dependencyGraph) {
        super(dependencyGraph);
        this.dependencyGraph = dependencyGraph;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars 
    add(value, address) {
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    remove(value, address) {
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    change(oldValue, newValue, address) {
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    applyChanges(contentChanges) {
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addColumns(columnsSpan) {
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removeColumns(columnsSpan) {
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removeSheet(sheetId) {
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    moveValues(sourceRange, toRight, toBottom, toSheet) {
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removeValues(range) {
    }
    /**
     * No-op: ColumnBinarySearch reads cell values directly from the dependency graph
     * on every lookup, so it has no cached data that could become stale.
     * Unlike ColumnIndex, which maintains a separate value-to-address index that
     * must be kept in sync with lazy transformations, binary search always operates
     * on the current graph state.
     */
    forceApplyPostponedTransformations() {
    }
    /*
     * WARNING: Finding lower/upper bounds in unordered ranges is not supported. When ordering === 'none', assumes matchExactly === true
     */
    find(searchKey, rangeValue, searchOptions) {
        return this.basicFind(searchKey, rangeValue, 'row', searchOptions);
    }
}
